import './styles/BaseComponents.css';
import './styles/mobile-nav-spacing.css';
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import StockPage from './pages/StockPage';
import PortfolioPage from './pages/PortfolioPage';
import Search from './pages/Search';
import ValueInvesting from './pages/content_pages/ValueInvesting';
import Articles from './pages/Articles';
import ArticleDetail from './pages/ArticleDetail';
import Header from './components/Header';
import Footer from './components/Footer';
import ImpressumPage from './pages/ImpressumPage';
import DatenschutzPage from './pages/DatenschutzPage';
import NotFound from './pages/NotFound';
import { AuthProvider } from './context/AuthContext';
import Toast from './components/Toast';
import SearchExplanation from './pages/content_pages/SearchExplanation';

// Scrolls to the top whenever the route changes (SPA navigation keeps the old
// scroll position otherwise, which feels broken on mobile).
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <Router>
          <ScrollToTop />
          <div className="app-shell">
            <Helmet defaultTitle="DynaStoxx - Intelligente Aktienanalyse" titleTemplate="%s">
              <meta name="description" content="DynaStoxx - Aktien finden, analysieren und dein Portfolio verfolgen. Kennzahlen, Dividenden und Wachstumsprognosen für Value-Investoren." />
              <meta name="theme-color" content="#0f172a" />
              <meta property="og:site_name" content="DynaStoxx" />
              <meta property="og:type" content="website" />
            </Helmet>
            <Header />
            <main className="app-main" id="main-content">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/stock-detail/:id" element={<StockPage />} />
                <Route path="/portfolio" element={<PortfolioPage />} />
                <Route path="/value-investing" element={<ValueInvesting />} />
                <Route path="/search" element={<Search />} />
                <Route path="/search-explained" element={<SearchExplanation />} />
                <Route path="/articles" element={<Articles />} />
                <Route path="/articles/:slug" element={<ArticleDetail />} />
                <Route path="/impressum" element={<ImpressumPage />} />
                <Route path="/datenschutz" element={<DatenschutzPage />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </main>
            <Footer />
            <Toast />
          </div>
        </Router>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
